
import { ArrowRightIcon } from "@heroicons/vue/24/solid";
import { Stream } from "@oculai/planner";
import { format, isBefore, subHours } from "date-fns";
import { defineComponent, PropType } from "vue";
import LiveBase from "@/views/partials/components/LiveBase.vue";

export default defineComponent({
  name: "StreamCard",
  props: {
    stream: {
      type: Object as PropType<Stream>,
      required: true,
    },
  },
  components: {
    ArrowRightIcon,
    LiveBase,
  },
  computed: {
    routerConnectionLostMessage() {
      if (
        this.stream.status === "offline" &&
        this.stream.status_updated_at &&
        isBefore(this.stream.status_updated_at, subHours(new Date(), 1))
      ) {
        return `${this.$t("dashboard.project.stream_card.connection_lost_1")}${format(
          this.stream.status_updated_at,
          "dd.MM.yyyy HH:mm",
        )}${this.$t("dashboard.project.stream_card.connection_lost_2")}`;
      }

      return null;
    },
  },
});
